import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountSelectorComponent } from './account-selector.component';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountSelectorApiService } from './account-selector-api.service';

@NgModule({
  declarations: [AccountSelectorComponent],
  exports: [AccountSelectorComponent],
  imports: [
    CommonModule,
    GalaxyFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  providers: [AccountSelectorApiService],
})
export class AccountSelectorModule {}
